
import { Person } from './person';

export class Intermediary extends Person {
  constructor() { super("Intermediary"); }
}
